import { makeAutoObservable } from 'mobx';
import {AuthModel} from "../model/auth-model";
import {HTTP_STATUS_CODE} from "../utils/UHttp";

type VerificationStatus = 'verifying' | 'success' | 'expired' | 'error' | 'already-verified';

export class EmailVerificationViewModel {
    email: string = '';
    status: VerificationStatus = 'verifying';
    message: string | null = null;
    tokenParam : string | null = null
    private authModel: AuthModel;

    constructor() {
        makeAutoObservable(this);
        this.authModel = AuthModel.getInstance();
    }

    get getEmail() {
        return this.email
    }
    get getMessage() {
        return this.message
    }
    get getStatus() {
        return this.status
    }

    setToken = (token: string | null) => {
        this.tokenParam = token;

        if (token) {
            this.handleEmailVerification().then();
        }
    };

    setEmail = (email: string) => {
        this.email = email;
    };

    setStatus = (status: VerificationStatus = "verifying") => {
        this.status = status;
    };
    setMessage = (message: string | null) => {
        this.message = message;
    };

    handleEmailVerification = async () => {
        try {
            if(!this.tokenParam) return
            const result = await this.authModel.handleEmailVerification(this.tokenParam)

            if (result.status === HTTP_STATUS_CODE.OK && result.success) {
                this.setEmail(result.email || '');

                if (result.alreadyVerified) {
                    this.setStatus('already-verified');
                } else {
                    this.setStatus('success');
                }
            } else {

                this.setStatus(result.tokenExpired ? 'expired' : 'error');
            }

        } catch (error: any) {
            this.setStatus('error');
        }
    }
    handleResendEmailVerification = async () => {
        try {
            const result = await this.authModel.handleResendEmailVerification(this.email)

            if (result.status === HTTP_STATUS_CODE.OK && result.success) {
                this.setMessage(result.message);

            }

            this.setMessage(result.message);

        } catch (error: any) {
            this.setMessage("Une erreur est survenue. Veuillez réessayer plus tard.");
        } finally {
        }
    }
}

const emailVerificationViewModel = new EmailVerificationViewModel();

export const useEmailVerificationViewModel = () => {
    return emailVerificationViewModel
}